import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOHeadProps {
  title?: string;
  description?: string;
  image?: string;
  type?: "website" | "movie" | "tv";
  url?: string;
  keywords?: string;
  structuredData?: Record<string, any>;
}

export const SEOHead = ({
  title = "Cinédelux - Découvrez les meilleurs films et séries",
  description = "Explorez les derniers films et séries, regardez des bandes-annonces et gérez votre liste de favoris sur Cinédelux.",
  image = "https://images.unsplash.com/photo-1536440136628-849c177e76a1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80",
  type = "website",
  url = typeof window !== "undefined" ? window.location.href : "",
  keywords = "films, séries, cinéma, streaming, bandes-annonces, acteurs, critiques, films populaires, séries Netflix, nouveautés cinéma, films 2024, séries TV, films en français, critiques de films, films d'action, films de science-fiction, séries fantastiques",
  structuredData,
}: SEOHeadProps) => {
  const fullTitle = title === "Cinédelux" ? title : `${title} | Cinédelux`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="fr" />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Cinédelux" />
      <meta property="og:locale" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@MartinR35832934" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};
